/**
 * The agency tab bar, shared by AdminLayout and the prototype header.
 */

import type { TabItem, TabGroupConfig } from "@/components/ui/TabGroup";
import { ENTITY_CONFIG } from "@/core/entityConfig";

// Tasks comes first and is the home: `/` redirects to `/tasks` (DD-049).
export const NAV_TABS: TabItem[] = [
  { id: "/tasks", label: ENTITY_CONFIG.task.plural },
  { id: "/clients", label: "Clients" },
  { id: "/leads", label: "Leads" },
  { id: "/finance", label: ENTITY_CONFIG.finance.label },
  { id: "/places", label: "Places" },
  { id: "/setup", label: "Setup" },
];

export const NAV_TAB_CONFIG: TabGroupConfig = {
  variant: "navigation",
  size: "sm",
  layout: "horizontal",
  hasBackground: true,
};
